import { connect } from 'react-redux';
import { LocalizedText, withScopeContext } from '@mews/framework';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { SummaryRow } from '../../SummaryRow';
import { openResourceDialog as openResourceDialogAction } from '../../../../../actions';
import ResourceCategoriesList from './ResourceCategoriesList';

interface OwnProps {
    scope: string;
    serviceId: string;
}

interface DispatchProps {
    openNightsDialog(): void;
}

type ResourceCategoriesProps = OwnProps & DispatchProps;

const ResourceCategories: React.FC<ResourceCategoriesProps> = ({ openNightsDialog, serviceId, scope }) => (
    <SummaryRow
        label={<LocalizedText textKey={TextKey.ResourcePlural} />}
        action={openNightsDialog}
        dataTestId={DataTestId.ReservationModuleResourceDialog}
        body={<ResourceCategoriesList serviceId={serviceId} scope={scope} />}
    />
);

export default withScopeContext(
    connect<null, DispatchProps, OwnProps>(null, (dispatch: CommanderThunkDispatch, { scope, serviceId }) => ({
        openNightsDialog: () => dispatch(openResourceDialogAction({ scope, serviceId })),
    }))(ResourceCategories)
);
